const contacts = [
  {
    id: 1,
    alt: 'LinkedIn link',
    ref: 'https://www.linkedin.com/in/kerron-shawn-king',
    imgSrc: 'https://img.icons8.com/material-rounded/48/000000/linkedin.png',
  },
  {
    id: 2,
    alt: 'Twitter',
    ref: 'https://twitter.com/KerronTriniDev',
    imgSrc: 'https://img.icons8.com/material-rounded/48/000000/twitter-squared.png',
  },
  {
    id: 3,
    alt: 'Github',
    ref: 'https://github.com/KerronKing',
    imgSrc: 'https://img.icons8.com/material-rounded/48/000000/github.png',
  },
];

export default contacts;
